module.exports = __webpack_public_path__ + "img/icon_quick_insta.24e6139f.svg";